import { useCallback, useEffect, useState } from 'react'

const TUTORIAL_STORAGE_KEY = 'tutorial-completed'

export function useTutorial(tutorialId: string) {
  const storageKey = `${TUTORIAL_STORAGE_KEY}-${tutorialId}`

  const [isOpen, setIsOpen] = useState(false)
  const [hasCompletedBefore, setHasCompletedBefore] = useState<boolean>(() => {
    try {
      return localStorage.getItem(storageKey) === 'true'
    } catch {
      return false
    }
  })

  const startTutorial = useCallback(() => {
    setIsOpen(true)
  }, [])

  const completeTutorial = useCallback(() => {
    setIsOpen(false)
    setHasCompletedBefore(true)
    try {
      localStorage.setItem(storageKey, 'true')
    } catch (error) {
      console.error('Failed to save tutorial completion state:', error)
    }
  }, [storageKey])

  const skipTutorial = useCallback(() => {
    setIsOpen(false)
    setHasCompletedBefore(true)
    try {
      localStorage.setItem(storageKey, 'true')
    } catch (error) {
      console.error('Failed to save tutorial skip state:', error)
    }
  }, [storageKey])

  const resetTutorial = useCallback(() => {
    setHasCompletedBefore(false)
    try {
      localStorage.removeItem(storageKey)
    } catch (error) {
      console.error('Failed to reset tutorial state:', error)
    }
  }, [storageKey])

  // No auto-open on mount; consumers decide when to start (e.g., after first login)

  return {
    isOpen,
    hasCompletedBefore,
    startTutorial,
    completeTutorial,
    skipTutorial,
    resetTutorial,
  }
}


